import React from 'react';
import RadioButton from '../RadioButton';
import DOK from '../DOK';
import CustomFeedback from '../CustomFeedback';
import AudioFeedback from '../AudioFeedback';
import QuestionDependency from '../QuestionDependency';
import OptionalImage from '../../lessonPlayer/components/OptionalImage';
import Utils from '../../lessonPlayer/services/UtilsService';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const Multiselect = ({ model, isManuscriptShort }) => {
  const answerMap = Utils.mapById(model.validation.answers);

  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Question Type:</div>
        <div>Multiple Select</div>
      </div>
      <div className='label-value-row'>
        <div>Question Number:</div>
        <div>{model.questionNumber}</div>
      </div>
      <div className='label-value-row'>
        <div>Point Value:</div>
        <div>{model.maxScore}</div>
      </div>
      <div className='label-value-row'>
        <div className='text-area-label'>Question:</div>
        <div className='ckeditor-text text-area'><HtmlComponent htmlStr={model.questionText} /></div>
      </div>
      <OptionalImage model={model} />
      <div className='choices'>
        <div>Choices:</div>
        <div>Correct</div>
        {model.answers.map((answer, idx) => {
          const validation = answerMap[answer.id];
          const selected = validation.isCorrect;
          const answerLetter = String.fromCharCode(65 + idx);

          return (
            <React.Fragment key={answer.id}>
              <div className='choice-letter'>{`${answerLetter}:`}</div>
              <div className='ckeditor-text text-area'><HtmlComponent htmlStr={answer.text} /></div>
              <div className='correct-button'>
                <RadioButton selected={selected} />
              </div>
            </React.Fragment>
          );
        })}
      </div>
      {/* advanced options */}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Answer Layout:</div>
            <div>{model.layout}</div>
          </div>
          <div className='label-value-row'>
            <div>Answer Icon Align Top:</div>
            <div>{model.anserTopJustify}</div>
          </div>
        </>
      )}
      <CustomFeedback model={model} />
      <div className='label-value-row'>
        <div>Hint:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.hint} /></div>
      </div>
      <div className='label-value-row'>
        <div>Solution:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.validation.solution} /></div>
      </div>
      {!isManuscriptShort && (
        <>
          <div className='label-value-row'>
            <div>Survey Question:</div>
            <div>{(model.survey) ? 'ON' : 'OFF'}</div>
          </div>
          <div className='label-value-row'>
            <div>Do Not Score:</div>
            <div>{(model.unscored) ? 'ON' : 'OFF'}</div>
          </div>
          <AudioFeedback model={model} />
          <div className='label-value-row'>
            <div>Randomize Answers:</div>
            <div>{(model.isRandomized) ? 'ON' : 'OFF'}</div>
          </div>
          <DOK model={model} />
        </>
      )}
    </div>
  );
};

export default Multiselect;
